import React, { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import cn from 'classnames';
import styles from './discountcode.module.scss';

type FirstServiceDiscountCodeProps = {
  code: string;
};

const FirstServiceDiscountCode = ({ code }: FirstServiceDiscountCodeProps) => {
  const [copied, setCopied] = useState(false);
  const title = copied ? 'Copied' : 'Copy Code';
  const copyStyles = cn(styles.firstServiceDiscountCodeCopy, 'text-link -no-decoration');
  return (
    <CopyToClipboard text={code} onCopy={() => setCopied(true)}>
      <div className={styles.firstServiceDiscountCode}>
        <div className={styles.firstServiceDiscountCodeText}>{code}</div>

        <button type="button" className={cn('plainButton', copyStyles)}>
          {title}
        </button>
      </div>
    </CopyToClipboard>
  );
};

export default React.memo(FirstServiceDiscountCode);
